import type { RouteRecordRaw } from 'vue-router';
import gettext from 'src/utils/gettext';
import { CompanyPermissionsCodename } from 'src/api';
import { requireCompanyPermission } from 'src/router/guards/requireCompanyPermission';

const { $gettext } = gettext;

export const officeRoutes: RouteRecordRaw[] = [
  {
    path: '',
    name: 'office',
    redirect: { name: 'services' },
  },
  {
    path: 'services',
    alias: $gettext('sluzby'),
    meta: { pageTitle: $gettext('Služby') },
    children: [
      {
        path: '',
        name: 'services',
        component: () => import('pages/office/ServicesPage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('nova'),
        name: 'services-new',
        component: () => import('pages/office/services/ServiceCreatePage.vue'),
      },
      {
        path: ':serviceId/edit',
        alias: $gettext(':serviceId/upravit'),
        name: 'services-update',
        props: true,
        component: () => import('pages/office/services/ServiceUpdatePage.vue'),
      },
      {
        path: 'category',
        alias: $gettext('kategorie'),
        children: [
          {
            path: 'new',
            alias: $gettext('nova'),
            name: 'service-groups-new',
            component: () =>
              import('pages/office/services/ServiceGroupCreatePage.vue'),
            props: (route) => ({
              next: route.query.next,
            }),
          },
          {
            path: ':serviceGroupId/edit',
            alias: $gettext(':serviceGroupId/upravit'),
            name: 'service-groups-update',
            props: true,
            component: () =>
              import('pages/office/services/ServiceGroupUpdatePage.vue'),
          },
        ],
      },
    ],
  },
  {
    path: 'Exercises',
    alias: $gettext('cviky'),
    meta: { pageTitle: $gettext('Cviky') },
    beforeEnter: requireCompanyPermission(
      CompanyPermissionsCodename.ALLOW_OFFICE
    ),
    children: [
      {
        path: '',
        name: 'exercises-overview',
        component: () =>
          import('pages/office/exercises/ExercisesOverviewExercisePage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('novy'),
        name: 'exercise-new',
        component: () =>
          import('pages/office/exercises/ExercisesCreateExercisePage.vue'),
      },
      {
        path: 'category',
        alias: $gettext('kategorie'),
        children: [
          {
            path: 'new',
            alias: $gettext('nova'),
            name: 'exercises-groups-new',
            component: () =>
              import('pages/office/exercises/ExerciseGroupCreatePage.vue'),
            props: (route) => ({
              next: route.query.next,
              mainCategoryId: route.query.mainCategoryId,
              createMainCategoryOnly: route.query.createMainCategoryOnly,
            }),
          },
          {
            path: 'edit',
            alias: $gettext('upravit'),
            name: 'exercise-groups-update',
            props: (route) => ({
              next: route.query.next,
              mainCategoryId: route.query.mainCategoryId,
              createMainCategoryOnly: route.query.createMainCategoryOnly,
              exerciseGroupId: route.query.exerciseGroupId,
            }),
            component: () =>
              import('pages/office/exercises/ExerciseGroupUpdatePage.vue'),
          },
        ],
      },
    ],
  },
  {
    path: 'Physiotherapists',
    alias: $gettext('Fyzioterapeuti'),
    meta: { pageTitle: $gettext('Uživatelé') },
    beforeEnter: requireCompanyPermission(
      CompanyPermissionsCodename.ALLOW_OFFICE
    ),
    children: [
      {
        path: '',
        name: 'users',
        component: () => import('pages/office/UsersPage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('novy'),
        name: 'create-user',
        component: () => import('src/pages/users/NewUserPage.vue'),
      },
      {
        path: ':userId/edit',
        alias: $gettext(':userId/upravit'),
        name: 'edit-user',
        props: true,
        component: () => import('src/pages/users/UpdateUserPage.vue'),
      },
      {
        path: ':userId/office-hours',
        alias: $gettext(':userId/ordinacni-hodiny'),
        name: 'working-hours',
        props: true,
        component: () => import('src/pages/users/WorkingHoursPage.vue'),
      },
    ],
  },
  {
    path: 'rooms',
    alias: $gettext('mistnosti'),
    beforeEnter: requireCompanyPermission(
      CompanyPermissionsCodename.ALLOW_OFFICE
    ),
    children: [
      {
        path: '',
        name: 'rooms',
        component: () => import('pages/office/rooms/RoomsListPage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('nova'),
        name: 'create-room',
        component: () => import('pages/office/rooms/RoomsCreatePage.vue'),
      },
      {
        path: ':roomId',
        children: [
          {
            path: 'edit',
            alias: $gettext('upravit'),
            name: 'update-room',
            props: true,
            component: () => import('pages/office/rooms/RoomsUpdatePage.vue'),
          },
        ],
      },
    ],
  },
  {
    path: 'locations',
    alias: $gettext('pobocky'),
    beforeEnter: requireCompanyPermission(
      CompanyPermissionsCodename.ALLOW_OFFICE
    ),
    children: [
      {
        path: '',
        name: 'locations',
        component: () => import('pages/office/locations/LocationsPage.vue'),
      },
      {
        path: 'new',
        alias: $gettext('nova'),
        name: 'create-location',
        component: () =>
          import('pages/office/locations/LocationsCreatePage.vue'),
      },
      {
        path: ':locationId',
        children: [
          {
            path: 'edit',
            alias: $gettext('upravit'),
            name: 'update-location',
            props: true,
            component: () =>
              import('pages/office/locations/LocationsUpdatePage.vue'),
          },
        ],
      },
    ],
  },
];
